import { IC_APPLICATION_NAME } from './constants';

const getLoginUrl = (continueUrl: string, isICEnabled?: boolean) => {
    const continueQuery = continueUrl
        ? `?continue=${encodeURIComponent(continueUrl)}`
        : '';

    if (isICEnabled) {
        const separator = continueQuery ? '&' : '?';
        return `${window.ID_AUTH_URL}/login${continueQuery}${separator}application=${IC_APPLICATION_NAME}`;
    }

    return `${window.ID_AUTH_URL}/login${continueQuery}`;
};

const getLogoutUrl = () => {
    return `${window.LOGOUT_URL}?continue=${encodeURIComponent(
        window.SAC_BASE_URL
    )}`;
};

export { getLoginUrl, getLogoutUrl };
